(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
  const els = document.querySelectorAll('.media-with-content[data-testid="media-with-content"][data-flyin]');

  els.forEach((el) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const target = entry.target;

        // rein: sobald >= 50% sichtbar -> Animation starten
        if (entry.intersectionRatio >= 0.5) {
          if (!target.classList.contains('flyin-start')) {
            target.classList.add('flyin-start');
          }
          return;
        }

        // raus: sobald fast nicht mehr sichtbar -> zurücksetzen
        if (entry.intersectionRatio <= 0.05) {
          if (target.classList.contains('flyin-start')) {
            target.classList.remove('flyin-start');

            // Animation sauber resetten
            target.style.animation = 'none';
            target.offsetHeight;
            target.style.animation = '';
          }
        }
      });
    }, {
      threshold: [0, 0.05, 0.5, 1]
    });

    observer.observe(el);
  });

  } catch(e) { console.error(e); }
})();
})();
